import {
  addServProject, delServProject, getOffset, getServProjectPage,
  offset, offsetList, updateServProject, bindServProject, delbindServProject, getServProjectByProductId,
  getServProjectBoolByProductId
} from '@/api/servProject'
import { message } from 'ant-design-vue'

export class ServController {
  static async page (params: COMMON.API.QueryParams) {
    const { code, data } = await getServProjectPage(params)
    return {
      code,
      data: data.records,
      sum: data.total
    }
  }

  static async add (data: SERV.Detail) {
    const { code, msg } = await addServProject(data)
    code === 0 ? message.success('新增成功') : message.error(msg)
  }

  static async update (data: SERV.Detail) {
    const { code, msg } = await updateServProject(data)
    code === 0 ? message.success('编辑成功') : message.error(msg)
    return code
  }

  static async del (id: string) {
    const { code, msg } = await delServProject(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
  }

  static async offset (data: {orderId: string, code: string, remark: string}) {
    const { code, msg } = await offset(data)
    code === 0 ? message.success('核销成功') : message.error(msg)
  }

  static async getOffsetByCode (_code: string) {
    const { code, data } = await getOffset(_code)
    return { code, data }
  }

  static async offsetList (params: COMMON.API.QueryParams & {orderLabel: string, giftsLabel: string, userLabel: string}) {
    const { code, data } = await offsetList(params)
    return {
      code,
      data: data.records,
      sum: data.total
    }
  }

  static async bindServProject (params: {projectIds: string[], productId: number, endTime: number}) {
    const { code, msg } = await bindServProject(params)
    code === 0 ? message.success('绑定成功') : message.error(msg)
  }

  static async delBindServProject (productId: number) {
    const { code, msg } = await delbindServProject(productId)
    code === 0 ? message.success('解除成功') : message.error(msg)
  }

  static async getServProjectByProductId (productId: number) {
    const { code, data } = await getServProjectByProductId(productId)
    return {
      code,
      data: data,
      sum: data
    }
  }

  static async getServProjectBoolByProductId (params: COMMON.API.QueryParams & {productId: string}) {
    const { code, data } = await getServProjectBoolByProductId(params)
    return {
      code,
      data: data.records,
      sum: data.total
    }
  }
}
